/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetAnswersDto } from './AssetAnswersDto';
import {
    AssetAnswersDtoFromJSON,
    AssetAnswersDtoFromJSONTyped,
    AssetAnswersDtoToJSON,
    AssetAnswersDtoToJSONTyped,
} from './AssetAnswersDto';
import type { AssetFinancialHoldingResponse } from './AssetFinancialHoldingResponse';
import {
    AssetFinancialHoldingResponseFromJSON,
    AssetFinancialHoldingResponseFromJSONTyped,
    AssetFinancialHoldingResponseToJSON,
    AssetFinancialHoldingResponseToJSONTyped,
} from './AssetFinancialHoldingResponse';

/**
 * 
 * @export
 * @interface AssetsTabResponse
 */
export interface AssetsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {AssetAnswersDto}
     * @memberof AssetsTabResponse
     */
    answers: AssetAnswersDto;
    /**
     * 
     * @type {Array<AssetFinancialHoldingResponse>}
     * @memberof AssetsTabResponse
     */
    financialHoldings: Array<AssetFinancialHoldingResponse>;
}

/**
 * Check if a given object implements the AssetsTabResponse interface.
 */
export function instanceOfAssetsTabResponse(value: object): value is AssetsTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('answers' in value) || value['answers'] === undefined) return false;
    if (!('financialHoldings' in value) || value['financialHoldings'] === undefined) return false;
    return true;
}

export function AssetsTabResponseFromJSON(json: any): AssetsTabResponse {
    return AssetsTabResponseFromJSONTyped(json, false);
}

export function AssetsTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'answers': AssetAnswersDtoFromJSON(json['answers']),
        'financialHoldings': ((json['financialHoldings'] as Array<any>).map(AssetFinancialHoldingResponseFromJSON)),
    };
}

export function AssetsTabResponseToJSON(json: any): AssetsTabResponse {
    return AssetsTabResponseToJSONTyped(json, false);
}

export function AssetsTabResponseToJSONTyped(value?: AssetsTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'answers': AssetAnswersDtoToJSON(value['answers']),
        'financialHoldings': ((value['financialHoldings'] as Array<any>).map(AssetFinancialHoldingResponseToJSON)),
    };
}

